import { render } from "./NotificationIndexComponent.vue?vue&type=template&id=d028c746"
import script from "./NotificationIndexComponent.vue?vue&type=script&lang=js"
export * from "./NotificationIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__